import React, { useState } from 'react';
import { baseUrlUser } from './common'; // Adjust path as needed
import './signup.css'; // We'll reuse your CSS styles

const SignUp = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    country: '',
    org: '',
    position: '',
    state: '',
    pinCode: '',
    phone: '',
    gstNumber: ''
  });

  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    const payload = {
      ...formData,
      pinCode: parseInt(formData.pinCode, 10) || 0,
      phone: parseInt(formData.phone, 10) || 0
    };

    try {
      const response = await fetch(`${baseUrlUser}users/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Failed to sign up. Status: ${response.status}, Response: ${text}`);
      }

      setMessage('✅ User signed up successfully!');
      setFormData({
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        country: '',
        org: '',
        position: '',
        state: '',
        pinCode: '',
        phone: '',
        gstNumber: ''
      });
    } catch (error) {
      console.error('Error signing up:', error.message);
      setMessage(`❌ Error: ${error.message}`);
    }
  };

  return (
    <div className="create-subscription-container">
      <h2>Sign Up New User</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <input type="password" name="password" value={formData.password} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>First Name:</label>
          <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Last Name:</label>
          <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Address Line 1:</label>
          <input type="text" name="addressLine1" value={formData.addressLine1} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Address Line 2:</label>
          <input type="text" name="addressLine2" value={formData.addressLine2} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>City:</label>
          <input type="text" name="city" value={formData.city} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>State:</label>
          <input type="text" name="state" value={formData.state} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Country:</label>
          <input type="text" name="country" value={formData.country} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Pin Code:</label>
          <input type="number" name="pinCode" value={formData.pinCode} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Phone:</label>
          <input type="number" name="phone" value={formData.phone} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Organization:</label>
          <input type="text" name="org" value={formData.org} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Position:</label>
          <input type="text" name="position" value={formData.position} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>GST Number:</label>
          <input type="text" name="gstNumber" value={formData.gstNumber} onChange={handleChange} />
        </div>
        <button type="submit">Sign Up</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default SignUp;
